module.exports = __webpack_public_path__ + "img/P12-en.edae99f1.png";